import React from 'react';
import { Toaster, toast } from 'react-hot-toast';
import { NJIM } from '../../../../theme/njimTheme';

const ToastNotification: React.FC = () => {
  return (
    <Toaster
      toastOptions={{
        style: {
          borderRadius: '12px',
          border: `1px solid ${NJIM.border}`,
          color: NJIM.textPrimary,
          fontSize: 14,
        },
        success: {
          style: {
            borderColor: NJIM.success,
          },
        },
        error: {
          style: {
            borderColor: NJIM.danger,
          },
        },
      }}
    />
  );
};

export const showToast = (message: string, type: 'success' | 'error' | 'loading' | 'custom' | 'info', duration: number = 3000) => {
  switch (type) {
    case 'success':
      toast.success(message, { duration });
      break;
    case 'error':
      toast.error(message, { duration });
      break;
    case 'loading':
      toast.loading(message, { duration });
      break;
    case 'custom':
    case 'info':
      toast(message, { duration });
      break;
    default:
      toast(message, { duration });
      break;
  }
};

export default ToastNotification;
